import React from 'react';
import { useNavigate } from 'react-router-dom';
import './HomePage.css';
import './MyPageExtend.css'; // 引入VIP Banner样式
import { services } from './servicesData';

const HomePage = () => {
  const navigate = useNavigate();

  const goDetail = (id) => {
    navigate(`/detail?serviceId=${id}`);
  };

  return (
    <div className="home-page">
      <header className="home-header">
        <h1>益美科技家政服务</h1>
        <p>成都益美美佳网络科技有限公司-专业家政服务平台</p>
      </header>

      <main className="home-main">
        <div className="container">
          
          {/* 联合会员入口 - 首页 */}
          <div className="vip-banner" onClick={() => navigate('/membership-package')} style={{marginBottom: '20px'}}>
               <div className="vip-content">
                  <div className="vip-left">
                      <span className="vip-icon">👑</span>
                      <div>
                          <h3 className="vip-title" style={{color: '#f3e5f5'}}>开通联合会员</h3>
                          <p className="vip-desc" style={{color: 'rgba(255,255,255,0.8)'}}>爱奇艺/腾讯等会员免费领 · 全场折扣</p>
                      </div>
                  </div>
                  <div className="vip-action">
                      <span style={{color: '#fbd87f'}}>立即查看</span>
                      <span className="vip-arrow" style={{color: '#fbd87f'}}>→</span>
                  </div>
               </div>
          </div>

          <section className="services-preview">
            <h2>我们的服务</h2>
            <div className="service-grid">
              {services.map(service => (
                <div
                  key={service.id}
                  className="service-card"
                  onClick={() => goDetail(service.id)}
                  role="button"
                  tabIndex={0}
                  onKeyDown={(e) => (e.key === 'Enter') && goDetail(service.id)}
                  aria-label={`查看${service.name}详情`}
                >
                  <img className="service-thumb" src={service.image} alt={service.name} loading="lazy" />
                  <div className="service-card-content">
                    <h3>{service.name}</h3>
                    <p>{service.description.slice(0, 22)}{service.description.length > 22 ? '…' : ''}</p>
                    <div className="service-card-footer">
                      <span className="price">¥{service.price}</span>
                      <span className="duration">{service.duration}</span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </section>

        </div>
      </main>
      <footer className="site-footer">
        <a
          href="https://beian.miit.gov.cn"
          target="_blank"
          rel="noopener noreferrer"
          className="icp-link"
        >
          蜀ICP备2025173074号
        </a>
      </footer>
    </div>
  );
};

export default HomePage;

